import { useEffect } from 'react';
import { IN_APP_HELP_COMPONENT } from 'navigation-components/config';
import { isHubSpotOrigin } from '../../../utils/isHubSpotOrigin';
import { validActions } from '../constants/DndMessage';
/**
 * Checks if the message is coming from the target component
 */
const isValidMessage = (originComponent = IN_APP_HELP_COMPONENT, targetComponent) => {
  return originComponent === targetComponent;
};

/**
 * Checks and sanitizes message events for the drag and drop widget
 */
export const getDndMessageHandler = (callback, componentName) => event => {
  if (!isHubSpotOrigin(event.origin)) {
    return;
  }
  const {
    data
  } = event;
  if (!isValidMessage(data.originComponent, componentName)) {
    return;
  }
  let action = '';
  let payload;
  if (typeof data === 'object' && data !== null && 'name' in data) {
    payload = data.payload;
    action = data.name;
  }
  if (typeof data === 'string') {
    try {
      const parsedData = JSON.parse(data);
      if (typeof parsedData === 'object' && parsedData !== null && 'name' in parsedData) {
        action = parsedData.name;
        payload = parsedData.payload;
      }
    } catch (e) {
      // do nothing
    }
  }
  const isValidAction = validActions[componentName];
  if (action && payload && isValidAction(action)) {
    callback(action, payload);
  }
};
export const useDndMessageHandler = (callback, componentName) => {
  useEffect(() => {
    const handleMessage = getDndMessageHandler(callback, componentName);
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [callback, componentName]);
};